import TreeSection from './TreeSection';
import {useGetSavedSearchList} from '../../../hooks/corpus/useCorpus';
import {t} from 'i18next';

const SavedSearchResultsSets = () => {
  return (
    <TreeSection
      fetchHook={useGetSavedSearchList}
      type={t('corpus.sectionType.savedSearchResultsSets')}
    />
  );
};

export default SavedSearchResultsSets;
